<div class="flex items-center justify-center gap-2 select-none">
  <button (click)="goToPage(1)" class="px-2 text-gray-400 hover:text-black cursor-pointer">
    &laquo;
  </button>

  <button
    (click)="goToPage(currentPage - 1)"
    class="px-2 text-gray-400 hover:text-black cursor-pointer"
  >
    &lsaquo;
  </button>

  <ng-container>
    @for (page of pages; track $index) {
    <button
      (click)="goToPage(page)"
      [ngClass]="{
        'bg-primary text-white': page === currentPage,
        'text-gray-500 hover:bg-red-light': page !== currentPage
      }"
      class="h-8 w-8 rounded-full font-medium cursor-pointer"
    >
      {{ page }}
    </button>
    }
  </ng-container>

  <button
    (click)="goToPage(currentPage + 1)"
    class="px-2 text-gray-400 hover:text-black cursor-pointer"
  >
    &rsaquo;
  </button>

  <button (click)="goToPage(totalPages)" class="px-2 text-gray-400 hover:text-black cursor-pointer">
    &raquo;
  </button>

  <select
    class="border border-gray-300 rounded px-2 py-1 ml-4 text-gray-700"
    [value]="itemsPerPage"
    (change)="changeItemsPerPage($event)"
  >
    @for (opt of [10, 20, 50, 100]; track $index) {
    <option [value]="opt" [selected]="opt == itemsPerPage">{{ opt }}</option>
    }
  </select>
</div>
